import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Container, Modal, Button, Carousel } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import "../styles/index.css";

// IMÁGENES
import logo from "../img/logoAmnorte.png";
import catalogoPDF from "../catalogo/CATALOGO ACEROS Y METALES.pdf";
import img1 from "../img/aceros.jpg";
import img2 from "../img/tubos.JPG";
import img3 from "../img/dobladora-tubo.JPG";
import img4 from "../img/tuberias.JPG";
import tuberiaRedonda from "../img/tuberia_redonda.JPG";
import tuberiaCedulas from "../img/tuberia_cedulas.JPG";
import tuboCerquero from "../img/tubo_cerquero.png";
import tuberiaCuadrada from "../img/tuberia_cuadrada.png";
import ptrImg from "../img/ptr.png";
import perfilesImg from "../img/p-puerta-verde.png";
import laminaImg from "../img/Lamina.png";

const menuItems = [
  { name: "Inicio", link: "/" },
  { name: "Nosotros", link: "/nosotros" },
  {
    name: "Productos",
    link: "/productos",
    dropdown: [
      { name: "Tubería Redonda", link: "/tuberia-redonda" },
      { name: "Tubería Redonda-Cédulas", link: "/tuberia-cedulas" },
      { name: "Tubo Cerquero", link: "/tubo-cerquero" },
      { name: "Tubería Cuadrada", link: "/tuberia-cuadrada" },
      { name: "PTR y Perfiles Rectangulares", link: "/ptr" },
      { name: "Perfiles Puerta", link: "/perfil-puerta" },
      { name: "Perfiles Ventana", link: "/perfil-ventana" },
      { name: "Ángulos y Soleras", link: "/angulos-soleras" },
      { name: "Lámina R-101", link: "/lamina-R-101" },
    ],
  },
  {
    name: "Servicios",
    link: "/servicio",
    dropdown: [
      { name: "Corte Láser", link: "/servicio#corte_laser" },
      { name: "Corte de Tubo", link: "/servicio#corte_tubo" },
      { name: "Doblez", link: "/servicio#doblez" },
      { name: "Doblez de Tubo", link: "/servicio#doblez-tubo" },
    ],
  },
  { name: "Contácto", link: "/contacto" },
];

// ---------------------------------------------
// NAVBAR
// ---------------------------------------------
const NavBar = () => {
  const navigate = useNavigate();
  const [navbarColor, setNavbarColor] = useState("rgba(53, 74, 102, 0.5)");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const carouselHeight = 350; // altura segura para móvil

      if (scrollY < carouselHeight) {
        setNavbarColor("rgba(53, 74, 102, 0.5)");
      } else {
        setNavbarColor("#354a66");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="lg" fixed="top" style={{ background: navbarColor }} className="navbar-custom">
      <Container fluid>
        <Navbar.Brand as={Link} to="/" style={{ color: "#fff" }}>
          <img src={logo} alt="Logo" height="50" className="me-2" />
          <span>Aceros y Metales</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbarNav" />
        <Navbar.Collapse id="navbarNav">
          <Nav className="ms-auto">
            {menuItems.map((item, index) =>
              item.dropdown ? (
                <NavDropdown key={index} title={item.name} id={`dropdown-${index}`}>
                  <NavDropdown.Item onClick={() => navigate(item.link)}>
                    {item.name}
                  </NavDropdown.Item>

                  <NavDropdown.Divider />

                  {item.dropdown.map((sub, i) => (
                    <NavDropdown.Item href={sub.link} key={i}>
                      {sub.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              ) : (
                <Nav.Link as={Link} to={item.link} key={index} style={{ color: "#fff" }}>
                  {item.name}
                </Nav.Link>
              )
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

// ---------------------------------------------
// CARRUSEL COMPLETO (RESPONSIVE REAL)
// ---------------------------------------------
const Carrusel = () => {
  return (
    <Carousel id="main-carousel" fade interval={3000} controls indicators>
      {[{
        img: img1,
        title: "AMNorte Aceros y Metales",
        text: "Aceros de calidad, soluciones que transforman"
      }, {
        img: img2,
        title: "Productos",
        text: "Conoce nuestro catálogo y la calidad del acero que trabajamos"
      }, {
        img: img3,
        title: "Servicios",
        text: "Corte láser, corte de tubo, doblez y más"
      }, {
        img: img4,
        title: "Contáctanos",
        text: "contacto@aymnorte.com.mx | +52 55 7583 9885"
      }].map((slide, idx) => (
        <Carousel.Item key={idx}>
          <img
            className="d-block w-100"
            src={slide.img}
            alt={slide.title}
            style={{
              width: "100%",
              height: "70vh",
              minHeight: "350px",
              objectFit: "cover",
              objectPosition: "center"
            }}
          />
          <Carousel.Caption className="bg-dark bg-opacity-50 p-3 rounded">
            <h2>{slide.title}</h2>
            <p>{slide.text}</p>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

// ---------------------------------------------
// DESCRIPCIÓN AMNORTE
// ---------------------------------------------
const DescripcionAMNorte = () => (
  <section className="descripcion_aymnorte">
    <div className="container text-center">
      <h2 style={{ fontSize: 30 }}>AMNorte Aceros y Metales</h2>
      <p style={{ textAlign: "justify", fontSize: 18 }}>
        Comercializadora Fuerte Grande del Norte (AMNorte Aceros y Metales) es una empresa 100% mexicana dedicada a la comercialización de acero a nivel nacional. Nos especializamos en ofrecer productos de alta calidad para sectores como construcción, manufactura e infraestructura.
      </p>
    </div>
  </section>
);

// ---------------------------------------------
// DESCARGA CATÁLOGO
// ---------------------------------------------
const DescargaCatalogo = () => (
  <section className="catalago text-center">
    <h1>Descarga Nuestro Catálogo</h1>
    <a href={catalogoPDF} download="Catalogo_Aceros_Metales.pdf">
      <button className="btn-catalgo">Descargar Catálogo</button>
    </a>
  </section>
);

// ---------------------------------------------
// PRODUCTOS
// ---------------------------------------------
const productosData = [
  ["Tubería Redonda", tuberiaRedonda, "/tuberia-redonda"],
  ["Tubería Cédulas", tuberiaCedulas, "/tuberia-cedulas"],
  ["Tubo Cerquero", tuboCerquero, "/tubo-cerquero"],
  ["Tubería Cuadrada", tuberiaCuadrada, "/tuberia-cuadrada"],
  ["PTR y Rectangulares", ptrImg, "/ptr"],
  ["Perfiles", perfilesImg, "/perfiles"],
  ["Lámina", laminaImg, "/lamina-R-101"]
];
const Productos = () => (
  <section className="nproductos text-center my-5">
    <h3>Nuestros Productos</h3>

    <div className="productos-container">
      {productosData.map(([title, img, link], i) => (
        <Link to={link} key={i} style={{ textDecoration: "none" }}>
          <div className="producto">
            <p>{title}</p>
            <img src={img} alt={title} />
          </div>
        </Link>
      ))}
    </div>
  </section>
);

// ---------------------------------------------
// WHATSAPP
// ---------------------------------------------
const WhatsAppButton = () => (
  <a href="https://wa.me/525547829794" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" width="60" />
  </a>
);

// ---------------------------------------------
// FOOTER
// ---------------------------------------------
const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="row text-center text-white">
        <div className="col-md-4">
          <h5>CONTÁCTANOS</h5>
          <p>Email: contacto@aymnorte.com.mx</p>
          <p>Teléfono: +52 55 4782 9794</p>
        </div>

        <div className="col-md-4">
          <h5>CORPORATIVO</h5>
          <p>Calzada Mariano Escobedo #476, Piso 12 Int. 1200 B, Anzures, CDMX</p>
        </div>

        <div className="col-md-4">
          <h5>CEDIS</h5>
          <p>KM 100 México-Querétaro, Jilotepec, Estado de México</p>
        </div>
      </div>

      <p className="text-center mt-3 text-white">
        AMNorte Aceros y Metales © 2025 - Todos los derechos reservados
      </p>
    </div>
  </footer>
);

// ---------------------------------------------
// INICIO (COMPLETO)
// ---------------------------------------------
const Inicio = () => {
  const [showAviso, setShowAviso] = useState(true);

  return (
    <div>
      <Modal show={showAviso} centered onHide={() => setShowAviso(false)}>
        <Modal.Header closeButton style={{ background: "#f58434d8", color: "#fff" }}>
          <Modal.Title>Aviso de Seguridad</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "#f58434d8", color: "#fff" }}>
          <p>
            <strong>¡Advertencia!</strong> Todos los correos oficiales de la empresa deben terminar en <strong>@aymnorte.com.mx</strong>.
          </p>
        </Modal.Body>
        <Modal.Footer style={{ background: "#f58434d8" }}>
          <Button variant="secondary" onClick={() => setShowAviso(false)}>
            Entendido
          </Button>
        </Modal.Footer>
      </Modal>

      <NavBar />
      <Carrusel />
      <DescripcionAMNorte />
      <DescargaCatalogo />
      <Productos />
      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default Inicio;
